import axios from 'axios';

const base = '/sac';

// ─────────────────────────────────────────────────────────────────────────────
// Catálogo (socio)
// ─────────────────────────────────────────────────────────────────────────────
export const getCatalog = () => axios.get(`${base}/catalog`).then((r) => r.data);
export const getLevels = () => axios.get(`${base}/levels`).then((r) => r.data);

// ─────────────────────────────────────────────────────────────────────────────
// Respuestas del socio
// ─────────────────────────────────────────────────────────────────────────────
export const createResponse = () => axios.post(`${base}/responses`).then((r) => r.data);
export const getMyResponses = (params = {}) =>
    axios.get(`${base}/responses/mine`, { params }).then((r) => r.data);
export const getMyLatest = () => axios.get(`${base}/responses/mine/latest`).then((r) => r.data);
export const getMyInProgress = () =>
    axios.get(`${base}/responses/mine/in-progress`).then((r) => r.data);
export const getResponse = (id) => axios.get(`${base}/responses/${id}`).then((r) => r.data);
export const upsertAnswers = (id, answers) =>
    axios.post(`${base}/responses/${id}/answers`, { answers }).then((r) => r.data);
export const completeResponse = (id) =>
    axios.post(`${base}/responses/${id}/complete`).then((r) => r.data);
export const abandonResponse = (id) =>
    axios.patch(`${base}/responses/${id}/abandon`).then((r) => r.data);
export const getResult = (id) => axios.get(`${base}/responses/${id}/result`).then((r) => r.data);

// ─────────────────────────────────────────────────────────────────────────────
// Share + PDF
// ─────────────────────────────────────────────────────────────────────────────
export const createShare = (id, ttlHours = null) =>
    axios.post(`${base}/responses/${id}/share`, { ttlHours }).then((r) => r.data);
export const revokeShare = (id) => axios.delete(`${base}/responses/${id}/share`).then((r) => r.data);
export const exportPdfUrl = (id) => `${axios.defaults.baseURL || ''}${base}/responses/${id}/export-pdf`;
export const downloadPdf = (id) =>
    axios.get(`${base}/responses/${id}/export-pdf`, { responseType: 'blob' }).then((r) => r.data);

// ─────────────────────────────────────────────────────────────────────────────
// Publicación en leaderboard (opt-in por intento)
// ─────────────────────────────────────────────────────────────────────────────
export const setPublishOnLeaderboard = (id, publish) =>
    axios.patch(`${base}/responses/${id}/publish`, { publish: publish ?? null }).then((r) => r.data);

// ─────────────────────────────────────────────────────────────────────────────
// Leaderboard público (sin auth)
// ─────────────────────────────────────────────────────────────────────────────
export const getLeaderboard = (params = {}) =>
    axios.get(`${base}/leaderboard`, { params }).then((r) => r.data);
export const getSharedResult = (token) =>
    axios.get(`${base}/shared/${encodeURIComponent(token)}`).then((r) => r.data);

// ─────────────────────────────────────────────────────────────────────────────
// Admin — cuestionario
// ─────────────────────────────────────────────────────────────────────────────
const adminBase = `${base}/admin`;

export const listRubros = (params = {}) =>
    axios.get(`${adminBase}/rubros`, { params }).then((r) => r.data);
export const createRubro = (data) => axios.post(`${adminBase}/rubros`, data).then((r) => r.data);
export const updateRubro = (id, data) => axios.put(`${adminBase}/rubros/${id}`, data).then((r) => r.data);
export const deleteRubro = (id) => axios.delete(`${adminBase}/rubros/${id}`).then((r) => r.data);

export const createSection = (data) => axios.post(`${adminBase}/sections`, data).then((r) => r.data);
export const updateSection = (id, data) => axios.put(`${adminBase}/sections/${id}`, data).then((r) => r.data);
export const deleteSection = (id) => axios.delete(`${adminBase}/sections/${id}`).then((r) => r.data);

export const createQuestion = (data) => axios.post(`${adminBase}/questions`, data).then((r) => r.data);
export const updateQuestion = (id, data) =>
    axios.put(`${adminBase}/questions/${id}`, data).then((r) => r.data);
export const deleteQuestion = (id) => axios.delete(`${adminBase}/questions/${id}`).then((r) => r.data);

export const createOption = (questionId, data) =>
    axios.post(`${adminBase}/questions/${questionId}/options`, data).then((r) => r.data);
export const updateOption = (id, data) => axios.put(`${adminBase}/options/${id}`, data).then((r) => r.data);
export const deleteOption = (id) => axios.delete(`${adminBase}/options/${id}`).then((r) => r.data);

// Admin — niveles
export const createLevel = (data) => axios.post(`${base}/levels`, data).then((r) => r.data);
export const updateLevel = (id, data) => axios.put(`${base}/levels/${id}`, data).then((r) => r.data);
export const deleteLevel = (id) => axios.delete(`${base}/levels/${id}`).then((r) => r.data);

// ─────────────────────────────────────────────────────────────────────────────
// Admin — dashboard
// ─────────────────────────────────────────────────────────────────────────────
const dashBase = `${adminBase}/dashboard`;

export const getDashboardOverview = () => axios.get(`${dashBase}/overview`).then((r) => r.data);
export const getDashboardByRubro = () => axios.get(`${dashBase}/by-rubro`).then((r) => r.data);
export const getDashboardBySection = (params = {}) =>
    axios.get(`${dashBase}/by-section`, { params }).then((r) => r.data);
export const getDashboardTrend = (params = {}) =>
    axios.get(`${dashBase}/trend`, { params }).then((r) => r.data);
export const getDashboardTopFlags = (params = {}) =>
    axios.get(`${dashBase}/top-flags`, { params }).then((r) => r.data);
export const getDashboardResponses = (params = {}) =>
    axios.get(`${dashBase}/responses`, { params }).then((r) => r.data);
export const getDashboardResponseDetail = (id) =>
    axios.get(`${dashBase}/responses/${id}`).then((r) => r.data);
